import VehicleImage from '@allesauto/core/vehicleImage';
import { useWhiteLabel } from '@allesauto/core/whiteLabel';
import React, { FC, useCallback } from 'react';

interface ThumbnailImageProps {
  src: string | null;
  imageBaseUrls: string;
  lastItem: boolean;
  numberOfItems: number;
  handleAction: (slide?: number) => void;
}

const ThumbnailImage: FC<React.PropsWithChildren<ThumbnailImageProps>> = ({
  src,
  lastItem,
  numberOfItems,
  handleAction,
}) => {
  const whiteLabel = useWhiteLabel();

  const className = {
    containerClass:
      'bg-grey10 cursor-pointer relative w-[17%] md:w-[10%] overflow-hidden',
    moreImagesClass: `absolute bg-green60 text-purple80 monochrome:bg-grey10 monochrome:text-black ${
      whiteLabel && '!text-white'
    } wl-bg-highlight wl-bg-highlight--hover wl-text-highlight flex font-headline font-weight-bold w-full h-full items-center justify-center opacity-80 text-center text-p1 top-0`,
  };

  const handleActionWrapped = useCallback(() => {
    handleAction();
  }, [handleAction]);

  return (
    <button
      onClick={handleActionWrapped}
      onKeyPress={handleActionWrapped}
      type="button"
      className={className.containerClass}
    >
      <VehicleImage
        aspectRatio="1_BY_1"
        filename={src || undefined}
        transformation="cover"
        pdPCarsImageAfterConfiguration
      />
      {lastItem && numberOfItems > 0 && (
        <span className={className.moreImagesClass}>+{numberOfItems}</span>
      )}
    </button>
  );
};

export default ThumbnailImage;
